import { ResourceScope } from '@app-types/blackroom-app';
import { TableProps } from '@app/shared/ui-kit/organisms/Table/types';
import {
  ListResourcesQueryVariables,
  Resource,
  ResourceRowFragmentFragment,
} from '@app/types/blackroom-api';
import {
  MRT_TableInstance,
  MRT_RowVirtualizer,
  MRT_SortingState,
} from 'mantine-react-table';
import React, { Dispatch, SetStateAction } from 'react';

export type ResourceColumn =
  | 'name'
  | 'index'
  | 'favorite'
  | 'createdBy'
  | 'createdAt'
  | 'updatedAt'
  | 'archivedAt'
  | 'size'
  | 'publicId'
  | 'actions';

export const RESOURCE_COLUMNS: ResourceColumn[] = [
  'index',
  'name',
  'favorite',
  'createdBy',
  'createdAt',
  'updatedAt',
  'archivedAt',
  'size',
  'publicId',
  'actions',
];

export function getResourceColumnSchema(
  scope: ResourceScope,
): Partial<Record<ResourceColumn, boolean>> {
  switch (scope) {
    case 'archived':
      return {
        index: true,
        name: true,
        createdBy: false,
        createdAt: false,
        updatedAt: false,
        size: false,
        publicId: false,
        archivedAt: true,
        actions: true,
      };
    default:
      return {
        index: true,
        name: true,
        favorite: true,
        createdBy: true,
        createdAt: true,
        updatedAt: false,
        size: false,
        publicId: false,
        actions: true,
      };
  }
}

export interface ResourceTableProps extends Omit<
  TableProps<ResourceRowFragmentFragment>,
  'columns'
> {
  columns?: Partial<Record<ResourceColumn, boolean>>;
  scope?: ResourceScope;
  onSelectResources?: (resources: ResourceRowFragmentFragment[]) => void;
  onSelectAllResources?: (selectAll: boolean) => void;
  withNavigation?: boolean;
  onTableReady?: (
    table: MRT_TableInstance<ResourceRowFragmentFragment>,
  ) => void;
  onClickResource?: (resource: ResourceRowFragmentFragment) => void;
  rowVirtualizerInstanceRef?: React.RefObject<MRT_RowVirtualizer>;
  parent?: Pick<Resource, 'id' | 'parentId'> | null;
  selectedResources: ResourceRowFragmentFragment[];
  selectAll?: boolean;
  requestVariables: ListResourcesQueryVariables;
  sorting: MRT_SortingState;
  onSortingChange: Dispatch<SetStateAction<MRT_SortingState>>;
}

export const PAGE_SIZE = 30;
